module.exports = __webpack_public_path__ + "static/media/ticket-icon.809361d9.svg";